import { useEffect, useMemo, useRef, useState } from "react"
import { Alert } from "@mui/material"
import {
  decodePointer,
  readPostBotError,
  type PostBotErrorDetail,
} from "../../utils/apiErrors"

export interface FeatureErrorsProps {
  error?: unknown
  /** Return true only after mapping document + decoded path + code to a form field.
   * Called outside render, once per error identity; false leaves a summary item. */
  onFieldError?: (detail: PostBotErrorDetail, segments: string[]) => boolean
}

export function FeatureErrors({ error, onFieldError }: FeatureErrorsProps) {
  const parsed = useMemo(
    () => (error == null ? undefined : readPostBotError(error)),
    [error],
  )
  const handler = useRef(onFieldError)
  handler.current = onFieldError
  const [routed, setRouted] = useState<{
    error: unknown
    details: PostBotErrorDetail[]
  }>()
  useEffect(() => {
    const details =
      parsed?.details.filter((detail) => {
        const segments = decodePointer(detail.path)
        return segments === null || !handler.current?.(detail, segments)
      }) ?? []
    setRouted({ error, details })
  }, [error, parsed])
  if (!parsed) return null
  const details =
    routed && routed.error === error ? routed.details : parsed.details
  return (
    <Alert severity="error">
      {typeof parsed.status === "string"
        ? "Не удалось выполнить запрос. Попробуйте ещё раз."
        : parsed.message}
      {details.length > 0 && (
        <ul>
          {details.map((detail, index) => (
            <li key={index}>
              {detail.document} {detail.path || "/"} — {detail.code}:{" "}
              {detail.message}
            </li>
          ))}
        </ul>
      )}
    </Alert>
  )
}
